import Vue from 'vue'
import utils from '@/util'

// api
import AuthApi from '@/api/auth'

export default (component) => Vue.component('SSOFormContainer', {
  data() {
    return {
      error: null,
      isSubmitting: false,
    }
  },
  created() {
    const error = utils.getParamValue('error')
    if (error) this.error = 'default_error'
  },
  methods: {
    async loginWithSSO(email) {
      try {
        this.isSubmitting = true
        const { redirectUrl } = await AuthApi.loginWithSSO({ email })

        setTimeout(() => {
          this.isSubmitting = false
        }, 2000)
        this.$func.go(redirectUrl)
      } catch (error) {
        this.isSubmitting = false
        this.error = this.$func.getErrorMessage(error, 'default_error')
      }
    },
  },
  render(createElement) {
    return createElement(component, {
      props: {
        error: this.error,
        loginWithSSO: this.loginWithSSO,
        isSubmitting: this.isSubmitting,
      },
    })
  },
})
